import { useEffect, useState } from 'react';
import { stageLabel } from '@ouradent/shared';
import { searchLeads } from '../lib/data';
import type { BoardLead } from '../lib/types';
import { Icon } from '../ui/icons';
import { CloseX, SrcBadge, useDrawer } from '../ui/kit';

export function SearchDrawer() {
  const { open } = useDrawer();
  const [q, setQ] = useState('');
  const [res, setRes] = useState<BoardLead[] | null>(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (q.trim().length < 2) {
      setRes(null);
      return;
    }
    let live = true;
    const t = setTimeout(() => {
      searchLeads(q)
        .then((r) => live && setRes(r))
        .catch((e: Error) => live && setErr(e.message));
    }, 180);
    return () => {
      live = false;
      clearTimeout(t);
    };
  }, [q]);

  return (
    <>
      <div className="dhead">
        <div style={{ flex: 1 }}>
          <h2 id="dtitle">Search</h2>
          <div className="sm">Leads by name, clinic, city, email or phone</div>
        </div>
        <CloseX />
      </div>
      <div className="dbody">
        <input
          className="srch"
          type="text"
          autoFocus
          autoComplete="off"
          aria-label="Search"
          placeholder="Name, clinic, city or phone"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <div className="panel" style={{ marginTop: 14 }}>
          {err ? (
            <div className="empty" style={{ padding: '6px 0', color: 'var(--red)' }}>
              {err}
            </div>
          ) : res === null ? (
            <div className="empty" style={{ padding: '6px 0' }}>
              Start typing.
            </div>
          ) : res.length === 0 ? (
            <div className="empty" style={{ padding: '6px 0' }}>
              Nothing found.
            </div>
          ) : (
            res.map((l) => (
              <button key={l.id} className="sres" onClick={() => open({ type: 'lead', id: l.id })}>
                <SrcBadge source={l.source} />
                <div className="grow">
                  <b>{l.clinic}</b>
                  <div style={{ color: 'var(--muted)', fontSize: 14 }}>
                    {l.person}
                    {l.city ? `, ${l.city}` : ''} · {stageLabel(l.stage)}
                  </div>
                </div>
                <Icon name="chev" />
              </button>
            ))
          )}
        </div>
      </div>
    </>
  );
}
